import {
  MergeQueueBranchMode,
  MergeQueueState,
  MergeQueueMergeStrategy,
  MergeQueueResponse,
  MergeQueueStrategy,
  PullRequestsOrderingCriteria,
} from 'src/components/merge-queues';

export class MergeQueue {
  readonly uuid: string = '';
  readonly createdOn: string = '';
  readonly lastUpdatedOn: string = '';
  readonly name: string = '';
  readonly strategy: MergeQueueStrategy = MergeQueueStrategy.STRICT_PER_PR;
  readonly buildConcurrency: number = 0;
  readonly branch: {
    mode: MergeQueueBranchMode;
    name?: string;
    type?: string;
    pattern?: string;
  } = {
    mode: MergeQueueBranchMode.BRANCH_NAME,
    name: '',
    type: '',
    pattern: '',
  };
  readonly mergeStrategy?: MergeQueueMergeStrategy;
  readonly mergeBatchSize?: number = 1;
  readonly maximumBatchWaitTimeInSeconds?: number = 0;
  readonly pullRequestsCount: number = 0;
  readonly pullRequestsOrdering?: {
    criteria: PullRequestsOrderingCriteria;
    sourceBranchPatterns: string[];
  };
  readonly state: MergeQueueState;

  constructor(props: Partial<MergeQueueResponse> = {}) {
    Object.assign(this, {
      uuid: props.uuid,
      createdOn: props.created_on,
      lastUpdatedOn: props.last_updated_on,
      name: props.name,
      strategy: props.strategy,
      buildConcurrency: props.build_concurrency,
      branch: {
        mode: props.branch?.mode,
        name: props.branch?.name,
        type: props.branch?.type,
        pattern: props.branch?.pattern,
      },
      mergeStrategy: props.merge_strategy,
      mergeBatchSize: props.merge_batch_size,
      maximumBatchWaitTimeInSeconds: props.maximum_batch_wait_time_in_seconds,
      pullRequestsCount: props.pullrequests_count,
      pullRequestsOrdering: props.pullrequests_ordering
        ? {
            criteria: props.pullrequests_ordering.criteria,
            sourceBranchPatterns:
              props.pullrequests_ordering.source_branch_patterns ?? [],
          }
        : undefined,
      state: props.state,
    });
  }

  get isActive(): boolean {
    return this.state === MergeQueueState.ACTIVE;
  }

  get isDraining(): boolean {
    return this.state === MergeQueueState.DRAINING;
  }

  get isInactive(): boolean {
    return this.state === MergeQueueState.INACTIVE;
  }
}
